import { useStyles } from 'bold-ui'
import { CSSProperties } from 'react'

export function SiteWrapper({ children }) {
  const { classes } = useStyles(createStyles)

  return (
    <div id='site-wrapper' className={classes.wrapper}>
      {children}
    </div>
  )
}

const createStyles = () => ({
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
})
